
const Terms = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-background">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto bg-card p-8 rounded-lg shadow-sm border border-border">
          <h1 className="text-3xl font-bold text-brand-blue dark:text-brand-orange mb-8">Conditions Générales d'Utilisation</h1>
          
          <div className="space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">1. Objet</h2>
              <p>
                Les présentes Conditions Générales d'Utilisation déterminent les règles d'accès et 
                d'utilisation des services proposés par Skillengers sur sa plateforme.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">2. Services</h2>
              <p>
                Skillengers propose une solution de gestion des compétences et des talents pour les entreprises.
                L'accès et l'utilisation de certains services peuvent être soumis à des conditions particulières.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">3. Responsabilités</h2>
              <p>
                L'utilisateur s'engage à utiliser les services conformément à leur destination et
                dans le respect des présentes conditions. Skillengers ne pourra être tenu responsable
                des dommages directs ou indirects résultant de l'utilisation de ses services.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
